import listItems from './ListItems';
import delivery from './Delivery';
import form from './Form';
import box from './Box';
import button from './Button';
import stickyFooter from './StickyFooter';
import footer2 from './Footer';
import gridItems from './GridItems';
import accordion from './Accordion';
import badge from './Badge';
import breadcrumb from './Breadcrumb';
import buttonGroup from './ButtonGroup';
import card from './Card';
import carousel from './Carousel';
import collapse from './Collapse';
import dropdown from './Dropdown';
import listGroup from './ListGroup';
import modal from './Modal';
import pagination1 from './Pagination';
import pagination2 from './Pagination2';
import pagination3 from './Pagination3';
import scrollspy from './Scrollspy';
import navbar from './Navbar';
import table from './Table';
import radios from './Radios';
import inlineRadios from './InlineRadios';
import listWithPagination from './ListWithPagination';
import switchBlock from './Switch';
import blogHome from './BlogHome';
import blogPost from './BlogPost';
import shopList from './ShopList';
import shopItem from './ShopItem';
import select2 from './Select2';
import textSection from './TextSection';
import textHeader1 from './TextHeader1';
import textHeader2 from './TextHeader2';
import textHeader3 from './TextHeader3';
import uploadImage from './UploadImage';
import dateField from './DateField';
import sidebar1 from './Sidebar1';
import sidebar2 from './Sidebar2';
import sidebar3 from './Sidebar3';
import sidebar4 from './Sidebar4';
import sidebar5 from './Sidebar5';
import sidebar6 from './Sidebar6';
import paragraph from './Paragraph';
import horizontalRule from './HorizontalRule';
import navbar2 from './Navbar2';
import table2 from './Table2';
import manageButton from './ManageButton';
import archiveButton from './ArchiveButton';
import deleteButton from './DeleteButton';
import previousButton from './PreviousButton';
import nextButton from './NextButton';
import select from './Select';
import inputArray from './InputArray';
import inputArraySelect from './InputArraySelect';
import formTemplate from './FormTemplate';
import tableTemplate from './TableTemplate';
import modernBusinessTemplate from './ModernBusinessTemplate';
import businessFrontPageTemplate from './BusinessFrontPageTemplate';
import listTemplate from './ListTemplate';
import itemTemplate from './ItemTemplate';
import signIn from './SignIn';
import { renderCustomBlocks, renderDataElementsBlocks, renderServiceBlocks } from '../../renderCreatedBlocks';
import login from './Login';
import login2 from './Login2';
import payment from './Payment';
import gallery from './Gallery';
import commentSection from './CommentSection';
import comparisonTable from './ComparisonTable';
import advancedComparisonTable from './AdvancedComparisonTable';
import comparisonCard from './ComparisonCard';
import faqSection from './FaqSection';
import invoice from './Invoice';
import contactForm from './ContactForm';
import orderDetails from './OrderDetails';
import profile from './Profile';
import signup from './SignUp';
import taskList from './TaskList';
import weatherWidget from './WeatherWidget';
import navbar3 from './Navbar3';
import login3 from './Login3';
import listTemplate2 from './ListTemplate2';
import dataTemplate from './DataTemplate';
import planTemplate from './PlanTemplate';
import simpleForm from './SimpleForm';
import taskTable from './TaskTable';
import mediaFooter from './MediaFooter';
import usersListTemplate from './UsersListTemplate';
import userInformationTemplate from './UserInformationTemplate';
import userTaskTemplate from './UserTasksTemplate';


function loadBlocks(editor) {
  if (editor !== undefined && editor.BlockManager !== undefined) {

    const bm = editor.BlockManager;

    
    

    editor.on('load', () => {



      editor.BlockManager.render([
        bm.get('column1').set('category', {
          label: 'Layout',
          open: true
        }),
        bm.get('column2').set('category', 'Layout'),
        bm.get('column3').set('category', 'Layout'),
        bm.get('column3-7').set('category', 'Layout'),

        bm.get('text').set('category', 'Typography'),
        bm.get('text').set(
          'content',
          `
          <div class='p-2 mw-100'>Insert your text here</div>
        `
        ),
        bm.get('link').set('category', 'Typography'),
        bm.get('link').set('content', `<a href='' class="pointer d-inline-block p-2">Link</a>`),

        bm.get('image').set('category', {
          label: 'Components',
          open: true
        }),

        bm.get('map').set('category', 'Components'),
        bm.get('tabs').set('category', 'Components'),
        bm.get('tabs').set(
          'label',
          `
              <svg height = '1.4vw' height='1.4vw' viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <g fill-rule="evenodd">
                  <path d="M22 9.3c0-.8-.5-1.3-1.3-1.3H3.4C2.5 8 2 8.5 2 9.3v7.4c0 .8.5 1.3 1.3 1.3h17.4c.8 0 1.3-.5 1.3-1.3V9.3zM21 17H3V9h18v8z" fill-rule="nonzero"></path><rect x="3" y="5" width="4" height="2" rx=".5"></rect><rect x="8" y="5" width="4" height="2" rx=".5"></rect><rect x="13" y="5" width="4" height="2" rx=".5"></rect>
                </g>
              </svg>
              <div class='gjs-fontFamily gjs-block-label'>Tabs</div>
              `
        ),
        bm.get('input').set('category', 'Forms '),
        bm.get('input').set(
          'label',
          `
              <svg width ="1.4vw" height = "1.4vw" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path class="gjs-block-svg-path" d="M22,9 C22,8.4 21.5,8 20.75,8 L3.25,8 C2.5,8 2,8.4 2,9 L2,15 C2,15.6 2.5,16 3.25,16 L20.75,16 C21.5,16 22,15.6 22,15 L22,9 Z M21,15 L3,15 L3,9 L21,9 L21,15 Z"></path>
                  <polygon class="gjs-block-svg-path" points="4 10 5 10 5 14 4 14"></polygon>
              </svg>
              <div class='gjs-block-label gjs-fontFamily'>Input</div>
              `
        ),
        bm.get('input').set('content', '<input type="text"  class="form-control p-2"/>'),
        bm.get('textarea').set('category', 'Forms '),
        bm.get('textarea').set(
          'label',
          `
              <svg width='1.4vw' height = '1.4vw' viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path class="gjs-block-svg-path" d="M22,7.5 C22,6.6 21.5,6 20.75,6 L3.25,6 C2.5,6 2,6.6 2,7.5 L2,16.5 C2,17.4 2.5,18 3.25,18 L20.75,18 C21.5,18 22,17.4 22,16.5 L22,7.5 Z M21,17 L3,17 L3,7 L21,7 L21,17 Z"></path>
                <polygon class="gjs-block-svg-path" points="4 8 5 8 5 12 4 12"></polygon>
                <polygon class="gjs-block-svg-path" points="19 7 20 7 20 17 19 17"></polygon>
                <polygon class="gjs-block-svg-path" points="20 8 21 8 21 9 20 9"></polygon>
                <polygon class="gjs-block-svg-path" points="20 15 21 15 21 16 20 16"></polygon>
              </svg>
              <div class='gjs-fontFamily'>Textarea</div>
              `
        ),
        bm.get('textarea').set('content', '<textarea name="-1" class="form-control"></textarea>'),
        bm.get('label').set('category', 'Forms '),
        bm.get('label').set(
          'label',
          `
                <svg  width ='1.4vw' height = '1.4vw' viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path class="gjs-block-svg-path" d="M22,11.875 C22,11.35 21.5,11 20.75,11 L3.25,11 C2.5,11 2,11.35 2,11.875 L2,17.125 C2,17.65 2.5,18 3.25,18 L20.75,18 C21.5,18 22,17.65 22,17.125 L22,11.875 Z M21,17 L3,17 L3,12 L21,12 L21,17 Z" fill-rule="nonzero"></path>
                    <rect class="gjs-block-svg-path" x="2" y="5" width="14" height="5" rx="0.5"></rect>
                    <polygon class="gjs-block-svg-path" fill-rule="nonzero" points="4 13 5 13 5 16 4 16"></polygon>
                </svg>
                <div class='gjs-fontFamily'>Label</div>
              `
        ),
        bm.get('label').set(
          'content', `<label  class="col-form-label p-2 font-weight-bold">Label</label>`),
        bm.get('checkbox').set('category', 'Forms '),
        bm.get('checkbox').set(
          'label',
          `
              <svg width='1.2rem' height='1.2rem' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M10 17l-5-5 1.41-1.42L10 14.17l7.59-7.59L19 8m0-5H5c-1.11 0-2 .89-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5a2 2 0 0 0-2-2z"></path></svg>
              <div class='gjs-fontFamily'>Checkbox</div>
              `
        ),
        bm.get('checkbox').set(
          'content',
          `
            <div class="form-check form-check-inline" wablitype="checkboxes">
              <input class="form-check-input" type="checkbox" value="Default checkbox" id="flexCheckDefault">
              <label class="form-check-label" for="flexCheckDefault">
                Default checkbox
              </label>
            </div>
            `
        ),
        bm.get('radio').set('category', 'Forms '),
        bm.get('radio').set(
          'label',
          `
              <svg width='1.2rem' height='1.2rem' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8m0-18C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 5c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5z"></path></svg>
              <div class='gjs-fontFamily'>Radio</div>
              `
        ),
        bm.get('radio').set(
          'content',
          `
            <div wablitype="radios" class="form-check form-check-inline">
              <input type="radio" id="flexRadioDefault1" value='radio' checked  class="form-check-input"/>
              <label for="flexRadioDefault1" class="form-check-label">
                radio
              </label>
            </div>
            `
        ),

        bm.get('custom-code').set('category', {
          label: 'Extra ',
          open: true
        }),
        bm.get('custom-code').set(
          'label',
          `
              <svg width= '1.4vw' height ='1.4vw' viewBox="0 0 24 24">
                <path d="M14.6 16.6l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4m-5.2 0L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4z"></path>
              </svg>
              <div class='gjs=block-label gjs-fontFamily'>Custom Code</div>
              `
        ),
        bm.get('tooltip').set('category', 'Extra '),
        bm.get('tooltip').set(
          'label',
          `
              <svg height='1.4vw' width='1.4vw' viewBox="0 0 24 24">
                <path d="M4 2h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2h-4l-4 4-4-4H4c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2m0 2v12h4.83L12 19.17 15.17 16H20V4H4z"></path>
              </svg>
              <div class='gjs-block-label gjs-fontFamily'>Tooltip</div>
              `
        )
      ]);

      // Buttons
      button(editor);
      manageButton(editor);
      archiveButton(editor);
      deleteButton(editor);
      previousButton(editor);
      nextButton(editor);
      dropdown(editor);
      buttonGroup(editor);

      // List
      listTemplate2(editor);
      taskList(editor);
      gridItems(editor);
      listItems(editor);
      listWithPagination(editor);

      // Forms
      contactForm(editor);
      delivery(editor);
      simpleForm(editor);
      form(editor);
      dateField(editor);
      select(editor);
      inputArray(editor);
      inputArraySelect(editor);

      box(editor);
      textSection(editor);
      // pairTexts(editor);
      accordion(editor);
      badge(editor);
      breadcrumb(editor);
      card(editor);
      carousel(editor);
      collapse(editor);
      listGroup(editor);
      modal(editor);
      pagination1(editor);
      pagination2(editor);
      pagination3(editor);
      scrollspy(editor);
      radios(editor);
      inlineRadios(editor);
      switchBlock(editor);
      select2(editor);
      uploadImage(editor);

      // Typography
      textHeader1(editor);
      textHeader2(editor);
      textHeader3(editor);
      paragraph(editor);
      horizontalRule(editor);

      // Navbars
      navbar3(editor);
      navbar(editor);
      navbar2(editor);
      footer2(editor);
      stickyFooter(editor);
      mediaFooter(editor);

      // Sidebars
      sidebar1(editor);
      sidebar2(editor);
      sidebar3(editor);
      sidebar4(editor);
      sidebar5(editor);
      sidebar6(editor);

      // Tables
      taskTable(editor);
      table(editor);
      table2(editor);
      comparisonTable(editor);

      // Login & Register
      login3(editor);
      login(editor);
      login2(editor);
      signup(editor);

      // Built In Components
      payment(editor);
      commentSection(editor);
      advancedComparisonTable(editor);
      comparisonCard(editor);
      faqSection(editor);
      invoice(editor);
      orderDetails(editor);
      gallery(editor);
      profile(editor);
      weatherWidget(editor);
      dataTemplate(editor);

      // Built in Templates
      usersListTemplate(editor);
      userInformationTemplate(editor);
      userTaskTemplate(editor);
      blogHome(editor); 
      blogPost(editor);
      formTemplate(editor);
      shopList(editor);
      shopItem(editor);
      tableTemplate(editor);
      modernBusinessTemplate(editor);
      businessFrontPageTemplate(editor);
      listTemplate(editor);
      itemTemplate(editor);
      signIn(editor);

      
      planTemplate(editor); // planTemplate must be the last one to be rendered
    
    

      const indexProject = JSON.parse(localStorage.getItem('selectedProject'));
      renderDataElementsBlocks(editor, indexProject);
      renderServiceBlocks(editor, indexProject);
      renderCustomBlocks(editor, indexProject);

    });
    editor.BlockManager.remove('header-layout');
    editor.BlockManager.remove('section');
    editor.BlockManager.remove('video');

  }
}

const LoadBlocks = {
  loadBlocks
};

export default LoadBlocks;
